import React, { useMemo } from "react";
import SelectField from "./SelectField";
import { ColSize } from "./TextField";
import moment from "moment-timezone";

interface Props {
  name: string;
  label?: string;
  col?: ColSize;
  onChange?: (value: string) => void;
}

export default function TimezoneField(props: Props) {
  const timezones = useMemo(() => moment.tz.names(), []);

  return (
    <SelectField
      label={props.label || "Timezone"}
      name={props.name}
      col={props.col}
      onChange={props.onChange}
    >
      <option value="">None Selected</option>
      {timezones.map((tz) => (
        <option key={tz}>{tz}</option>
      ))}
    </SelectField>
  );
}
